export class Tax {
  taxError?: {
      showError: boolean,
      showDialog: boolean,
      message: string
  };
  loccode: number | null;
  localrate: number | null;
  rate: number;
  code: number | null;
  addressline?: {
      code: number,
      street: string,
      househigh: string,
      houselow: string,
      evenodd: string,
      state: string,
      zip: string,
      plus4: string,
      period: string,
      rta: string,
      ptba: string,
      cez: string,
  };
  rateDetails: {
      name: string,
      code?: string,
      staterate?: string,
      localrate?: string
  }

  constructor() {
      this.loccode = 0;
      this.localrate = 0;
      this.rate = 0;
      this.code = 0;
      this.rateDetails = {
          name: ''
      };
  }
}


export class TaxError {
  showError: boolean;
  message: string;

  constructor() {
    this.showError = false;
    this.message = '';
  }
}
